import {type ReactNode, useMemo} from "react";
import {Property} from "csstype";
import Highcharts, {type Options} from "highcharts";
import mapModule from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";

import * as styles from "./Chart.module.css";

if (typeof Highcharts === "object") {
    mapModule(Highcharts);
}

interface IChart {
    height: Property.Height;
    width?: Property.Width;
    options: Options;
    loader?: ReactNode;
    type?: "mapChart" | "chart";
}

export const Chart = (props: IChart) => {
    const {height, loader, options = {}, width, type = "chart"} = props;

    const chartOptions: Options = useMemo(() => ({chart: {height}, credits: {enabled: false}, ...options}), [options]);

    if (loader) {
        return <div style={{height}}>{loader}</div>;
    }

    return (
        <div className={styles.container} style={{height: height || "100%", width: width || "100%"}}>
            <HighchartsReact constructorType={type} highcharts={Highcharts} options={chartOptions} />
        </div>
    );
};
import {type ReactNode, useMemo} from "react";
import {Property} from "csstype";
import Highcharts, {type Options} from "highcharts";
import mapModule from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";

import * as styles from "./Chart.module.css";

if (typeof Highcharts === "object") {
    mapModule(Highcharts);
}

interface IChart {
    height: Property.Height;
    width?: Property.Width;
    options: Options;
    loader?: ReactNode;
    type?: "mapChart" | "chart";
}

export const Chart = (props: IChart) => {
    const {height, loader, options = {}, width, type = "chart"} = props;

    const chartOptions: Options = useMemo(() => ({chart: {height}, credits: {enabled: false}, ...options}), [options]);

    if (loader) {
        return <div style={{height}}>{loader}</div>;
    }

    return (
        <div className={styles.container} style={{height: height || "100%", width: width || "100%"}}>
            <HighchartsReact constructorType={type} highcharts={Highcharts} options={chartOptions} />
        </div>
    );
};
